import React from 'react';
import { getTokens } from './tokenCatalog';
import './VariablePanel.css';

export const MERGE_TOKEN_DROP_TYPE = 'application/x-merge-token';

export function getMergeTokenHtml(variable) {
  const token = variable.token || variable.label || variable.key;
  return `<span class="merge-token" data-key="${variable.key}" data-token="${token}">${token}</span>`;
}

export default function VariablePanel({ onInsertVariable, templateType = 'invoice' }) {
  const handleVariableClick = (variable) => {
    if (onInsertVariable) {
      onInsertVariable(variable);
    }
  };

  const handleDragStart = (e, variable) => {
    e.dataTransfer.effectAllowed = 'copy';
    e.dataTransfer.setData('text/html', getMergeTokenHtml(variable));
    e.dataTransfer.setData(MERGE_TOKEN_DROP_TYPE, JSON.stringify(variable));
    e.dataTransfer.setData('text/plain', variable.token || variable.label || variable.key);
  };

  const variables = getTokens(templateType);

  return (
    <div className="variable-panel">
      <div className="variable-panel-header">
        <h3>Variables</h3>
        <p className="variable-panel-hint">Drag or click to insert into editor</p>
      </div>
      
      <div className="variable-list">
        {variables.map((variable) => (
          <div
            key={variable.key}
            role="button"
            tabIndex={0}
            className="variable-item"
            onClick={() => handleVariableClick(variable)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleVariableClick(variable);
              }
            }}
            draggable
            onDragStart={(e) => handleDragStart(e, variable)}
            title={variable.description || `Insert ${variable.label} (key: ${variable.key})`}
          >
            <span className="variable-item-display">{variable.token}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
